import PhoneNumberDisplayEditPage from './PhoneNumberDisplayEditPage'

export default PhoneNumberDisplayEditPage
